import React from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";
import { Icon, Image } from 'semantic-ui-react'
import userImage from '../../assets/img/NewProfileImage.png';
import logo from '../../assets/img/creightonLogo2.png'
import censio_logo from '../../assets/img/censio_logo.png'
// import RightSidelogo from '../../assets/img/OFFICIAL-Center-for-Enterprise-Value_Primary-SVG.png'
// import EntrepreneurialIcon from '../../assets/img/EntrepreneuriaICon.svg'
import ContactIcon from '../../assets/img/contactIocn.svg'
import { useDispatch, useSelector } from 'react-redux';
import { redirectTo } from "../../Components/routes/redirectToPath";
import { togglePopup } from "../../Actions/componentActions";
import { Paths } from "../../Components/routes/routePaths";
import { getBrandIntroductionPath } from "../../Components/routes/pathUtils";

const ENTREPRENEUR_CONTACT_RETURN_PATH = "entrepreneur_contact_return_path";

const navItems = [
  // {
  //   label: "Entrepreneurial",
  //   path: "/entrepreneur",
  //   icon: EntrepreneurialIcon,
  //   match: (pathname) => pathname === "/entrepreneur" || (pathname.startsWith("/entrepreneur/") && pathname !== Paths.EntrepreneurContactUs),
  // },
  {
    label: "Contact Us",
    path: Paths.EntrepreneurContactUs,
    icon: ContactIcon,
    match: (pathname) => pathname === Paths.EntrepreneurContactUs || pathname.startsWith(`${Paths.EntrepreneurContactUs}/`),
  },
];

export default function EntrepreneurHeader({ homeURL }) {
  const profileDetail = useSelector(state => (state.profileReducer.profileDetail));
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  let userRole = profileDetail?.data?.user?.role

  const isCreighton = window.location.href
    .toLowerCase()
    .includes("creighton");

  const brandBasePath = isCreighton ? '/creighton' : '/entrepreneur';
  const contactRoutePath = isCreighton ? Paths.CreightonContactUs : Paths.EntrepreneurContactUs;

  const saveCurrentEntrepreneurPath = () => {
    const currentPath = `${location.pathname}${location.search}${location.hash}`;
    if (currentPath.startsWith(brandBasePath) && currentPath !== contactRoutePath) {
      sessionStorage.setItem(ENTREPRENEUR_CONTACT_RETURN_PATH, currentPath);
    }
  };

  const getSavedEntrepreneurPath = () => {
    const savedPath = sessionStorage.getItem(ENTREPRENEUR_CONTACT_RETURN_PATH);
    if (savedPath && savedPath.startsWith(brandBasePath) && savedPath !== contactRoutePath) {
      return savedPath;
    }
    return null;
  };

  const getEntrepreneurReturnPath = () => {
    return location.pathname === contactRoutePath
      ? getSavedEntrepreneurPath() || `${brandBasePath}/introduction`
      : brandBasePath;
  };

  const handleOnLogoClick = () => {
    if (location.pathname === contactRoutePath) {
      const savedPath = getSavedEntrepreneurPath();
      if (savedPath) {
        history.push(savedPath);
        return;
      }
    }

    let redirectUrl = redirectTo[userRole]
    history.push(!userRole && redirectUrl ? redirectUrl : !userRole ? homeURL || '/' : getBrandIntroductionPath(location.pathname))
  }

  const handleProfileClick = () => {
    dispatch(togglePopup({ open: true, type: 'Profile', crossIcon: false, className: '', popUpPosition: 'top-[5.8rem] left-1/2 -translate-x-1/2 sm:left-auto sm:translate-x-0 sm:right-4 lg:right-[10rem]' }))
  }

  const isActive = ({ path, match }) => {
    if (typeof match === "function") {
      return match(location.pathname);
    }
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const getNavClasses = (active, mobile = false) => {
    const baseClasses = mobile
      ? "group flex items-center gap-1.5 px-3 py-2 text-[13px] font-medium no-underline transition-colors duration-200"
      : "group flex items-center gap-1.5 px-3 py-2 text-[13px] font-medium no-underline transition-colors duration-200";

    return baseClasses;
  };

  return (
    <header
      className={`w-full sticky top-0 z-[60] border-b ${isCreighton
          ? "text-white border-white/[0.08] bg-[linear-gradient(135deg,_#002447_0%,_#0069D1_100%)]"
          : "text-gray-800 border-[#E2E8F0] bg-[linear-gradient(135deg,_#d9d9d9 0%,_#E6F2FF_100%)]"
        }`}
      style={{
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
      }}
    >
      <div className="mx-auto flex min-h-[75px] w-full max-w-[1280px] items-center justify-between gap-8 px-5 lg:px-14">
        <div className="flex min-w-0 flex-col gap-[3px] leading-none">
          <button
            onClick={handleOnLogoClick}
            className="flex h-[48px] shrink-0 items-center transition-opacity duration-200 hover:opacity-90"
          >
            <img
              loading="lazy"
              src={isCreighton ? logo : censio_logo}
              alt="logo"
              className="h-full w-auto object-contain"
            />
          </button>
        </div>

        <div className="flex items-center gap-5">
          <nav className="hidden items-center gap-5 lg:flex">
            {navItems.map((item) => {
              const { label, icon } = item;
              const isContactItem = item.path === Paths.EntrepreneurContactUs;
              const path = isContactItem ? contactRoutePath : item.path;
              
              const activeItem = {
                ...item,
                path,
                match: isContactItem 
                  ? (pathname) => pathname === contactRoutePath || pathname.startsWith(`${contactRoutePath}/`)
                  : item.match
              };

              const active = isActive(activeItem);
              const resolvedPath = path === brandBasePath ? getEntrepreneurReturnPath() : path;
              return (
                <Link
                  key={path}
                  to={resolvedPath}
                  onClick={isContactItem ? saveCurrentEntrepreneurPath : undefined}
                  className={getNavClasses(active)}
                  style={{
                    color: active
                      ? (isCreighton ? '#FFFFFF' : '#1E5BC6')
                      : (isCreighton ? '#B8C5D9' : '#6B7280'),
                    textDecoration: 'none',
                    backgroundColor: 'transparent',
                  }}
                >
                  <img
                    src={icon}
                    alt=""
                    loading="lazy"
                    className={`h-4 w-4 ${isCreighton ? 'brightness-0 invert' : ''} ${active ? 'opacity-100' : 'opacity-60'}`}
                  />
                  <span>{label}</span>
                </Link>
              );
            })}
          </nav>

          {userRole ? (
            <div
              className={`flex cursor-pointer items-center gap-2 rounded-full border px-3 py-1.5 transition-all duration-200 ${isCreighton
                  ? "border-white/[0.18] bg-white/[0.10] hover:bg-white/[0.18]"
                  : "border-[#E2E8F0] bg-white hover:bg-gray-50"
                }`}
              onClick={handleProfileClick}
            >
              <Image
                src={profileDetail?.data?.user?.user_image || userImage}
                loading="lazy"
                className="h-[34px] w-[34px] rounded-full object-cover"
              />
              <span className={`text-sm font-bold ${isCreighton ? 'text-white' : 'text-[#0f172a]'}`}>
                {profileDetail?.data?.user?.first_name 
                  ? `${profileDetail.data.user.first_name} ${profileDetail.data.user.last_name || ''}`.trim()
                  : sessionStorage.getItem("userName") || "Admin"}
              </span>
              <Icon className={`caret down !m-0 ${isCreighton ? '!text-white' : '!text-[#0f172a]'} !opacity-100`} style={{ color: isCreighton ? '#FFFFFF' : '#0f172a', opacity: 1 }} />
            </div>
          ) : (
            <button
              type="button"
              onClick={() => history.push(isCreighton ? '/creighton/auth-gateway' : '/entrepreneur/auth-gateway')}
              className="rounded-md border border-[#1E5BC6] bg-[#122359] px-5 py-2.5 text-[13px] font-semibold text-white shadow-[0_4px_12px_-4px_rgba(30,91,198,0.40)] transition-all duration-200 hover:bg-[#0B3B95] hover:border-[#0B3B95] hover:shadow-[0_8px_24px_-8px_rgba(30,91,198,0.50)]"
            >
              Log In/Sign Up
            </button>
          )}
        </div>
      </div>

      <div className={`border-t px-5 py-2.5 lg:hidden ${isCreighton ? 'border-white/[0.08]' : 'border-[#E2E8F0]'}`}>
        <div className="flex flex-wrap items-center gap-2">
          {navItems.map((item) => {
            const { label, icon } = item;
            const isContactItem = item.path === Paths.EntrepreneurContactUs;
            const path = isContactItem ? contactRoutePath : item.path;
            
            const activeItem = {
              ...item,
              path,
              match: isContactItem 
                ? (pathname) => pathname === contactRoutePath || pathname.startsWith(`${contactRoutePath}/`)
                : item.match
            };

            const active = isActive(activeItem);
            const resolvedPath = path === brandBasePath ? getEntrepreneurReturnPath() : path;
            return (
              <Link
                key={path}
                to={resolvedPath}
                onClick={isContactItem ? saveCurrentEntrepreneurPath : undefined}
                className={getNavClasses(active, true)}
                style={{
                  color: active
                    ? (isCreighton ? '#FFFFFF' : '#1E5BC6')
                    : (isCreighton ? '#B8C5D9' : '#6B7280'),
                  textDecoration: 'none',
                  backgroundColor: 'transparent',
                }}
              >
                <img
                  src={icon}
                  alt=""
                  loading="lazy"
                  className={`h-4 w-4 ${isCreighton ? 'brightness-0 invert' : ''} ${active ? 'opacity-100' : 'opacity-60'}`}
                />
                <span>{label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </header>
  );
}
